import { createProvider } from '@frontend/store';
import { StoreConstants } from './constants';
import { FormsSendingExperienceStore } from './types';
import { StoreUtils } from './utils';

/**
 * This store (context) is used to hold the state of the WritebackWidget
 */
export const { Provider: SendFormsStoreProvider, useStore: useSendFormsStore } =
  createProvider<FormsSendingExperienceStore>()((set, get) => ({
    ...StoreConstants.INITIAL_STATE,
    setFormOrPacketToSend: (document) => set({ formOrPacketToSend: document }),
    setSolicitedLink: (solicitedLink) => set({ solicitedLink }),
    setSubmissionToken: (submissionToken) => set({ submissionToken }),
    setIsCreatingTransientForm: (isCreatingTransientForm) => set({ isCreatingTransientForm }),
    setCurrentStep: (step) => set({ currentStep: step }),
    setSteps: (steps) => set({ steps }),
    getStepData: () => {
      const { currentStep, steps } = get();
      return {
        currentStep,
        steps,
      };
    },
    setIsSending: (isSending) => set({ isSending }),
    setIsGeneratingSolictedLink: (isGeneratingSolicitedLink) => set({ isGeneratingSolicitedLink }),
    setPersonId: (personId) => set({ personId }),
    setPersonName: ({ firstName, lastName }) =>
      set({
        firstName,
        lastName,
        fullName: `${firstName} ${lastName}`.trim(),
      }),

    setAppointmentInfo: (appointmentInfo) =>
      set(() => ({
        appointmentInfo,
      })),

    clearAppointmentInfo: () =>
      set({
        appointmentInfo: null,
      }),

    setAppointmentId: (appointmentId) => set({ appointmentId }),
    setAcceptedFiles: (files) => set({ acceptedFiles: files }),
    setRejectedFiles: (files) => set({ rejectedFiles: files }),

    clearStore: (origin) => {
      set((state) => {
        return StoreUtils.resetStore({ currentState: state, origin });
      });
    },

    setEmail: (email) => set({ email }),
    setEmailBody: (emailBody) => set({ emailBody }),
    setEmailSubject: (emailSubject) => set({ emailSubject }),
    getEmailPayload: () => {
      const { email, emailSubject, emailBody } = get();
      return {
        email,
        emailSubject,
        emailBody,
      };
    },

    setShowMessageComponent: (showMessageComponent) => set({ showMessageComponent }),
    setIsUploadInProgress: (isUploadInProgress) => set({ isUploadInProgress }),
    setTemporarilyHideModal: (temporarilyHideModal) => set({ temporarilyHideModal }),
    setSelectedDeliveryMethod: (selectedDeliveryMethod) => set({ selectedDeliveryMethod }),
    setLocationId: (locationId) => set({ locationId }),
    setFormsEnabledLocationIds: (locationIds) =>
      set({
        formsEnabledLocationIds: locationIds,
        areFormsEnabledLocationIdsSet: true,
      }),

    getGenerateLinkPayload: () => {
      const { formOrPacketToSend, acceptedFiles } = get();
      return {
        formOrPacketToSend,
        acceptedFiles,
      };
    },
  }));
